import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 6" {...props}>
    <path
      fill="#919499"
      fillRule="evenodd"
      d="M.625 5.486 0 4.705 5.881 0l5.748 4.709-.632.773-5.123-4.195z"
    />
  </svg>
);
const Memo = memo(SvgArrowDown);
export default Memo;
